// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__2siwg","img":"list_img__13u4l","address":"list_address__8T4fx","price":"list_price__2ZwuB"};